module.exports = __webpack_public_path__ + "static/media/Stellar King Bed Base - 180x210 cm_Natural.7dfb3b55.png";